var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { createClassListFromModifiers } from '../core/utils/class-helper';
import PhotoFrame from '../modules/Photo/PhotoFrame';
import ResizedPhoto from '../modules/Photo/ResizedPhoto';
var CartItemImage = /** @class */ (function (_super) {
    __extends(CartItemImage, _super);
    function CartItemImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartItemImage.prototype.render = function () {
        var classList = __spreadArray([
            'c-cart-item-image'
        ], createClassListFromModifiers('c-cart-item-image', this.props.modifier));
        return (React.createElement("div", { className: classList.join(' ') }, this.renderPhoto()));
    };
    CartItemImage.prototype.renderPhoto = function () {
        if (3 === this.props.item.product.id && this.props.item.product_variant_id) {
            return (React.createElement("img", { className: "c-cart-item-image__image", src: "/images/products/variants/" + this.props.item.product_id + "/" + this.props.item.product_variant_id + ".jpg", alt: "" }));
        }
        if (this.props.item.photos.length) {
            return (React.createElement(PhotoFrame, { photo: this.props.item.photos[0], crop: true, shadow: true },
                React.createElement(ResizedPhoto, { photo: this.props.item.photos[0] })));
        }
        return null;
    };
    return CartItemImage;
}(React.Component));
export default withTranslation()(CartItemImage);
